<template>
  <v-flex
    column
    role="region"
    aria-label="Dashboard content"
  >
    <v-parallax
      src="https://gm.goz.fun/wp-content/uploads/2023/03/dashboard-cover.png"
      height="350"
      role="img"
      aria-label="Dashbiard section banner with themed illustration"
    />
    <v-card flat>
      <v-layout
        column
        pb-2
      >
        <v-flex
          xs12
          sm12
          md8
          lg8
          justify-center
        >
          <v-card
            class="profile-section-card--flex-toolbar"
            flat
          >
            <v-flex
              xs12
              offset-xs0
              sm12
              offset-sm0
              md10
              offset-md1
              lg10
              offset-lg1
              justify-center
            >
              <v-app-bar
                flat
                color="secondary"
                role="navigation"
              >
                <v-toolbar-title
                  id="profileWelcome"
                  class="text-body-2"
                >
                  {{ $t("components.profile.welcome") }}
                  {{ nickname }}
                </v-toolbar-title>
              </v-app-bar>
            </v-flex>

            <v-progress-linear
              v-show="isLoading"
              color="accent"
              indeterminate
              role="progressbar"
              aria-label="Loading"
            />

            <v-card flat>
              <v-container
                fluid
                grid-list-md
              >
                <v-tabs
                  fixed-tabs
                  color="accent"
                  show-arrows
                  centered
                  next-icon="fad fa-chevron-right"
                  prev-icon="fad fa-chevron-left"
                  slider-color="accent"
                  role="tablist"
                  aria-labelledby="profileWelcome"
                >
                  <v-tabs-slider />

                  <v-tab
                    v-for="tab in tabs"
                    :key="tab.id"
                    :to="tab.route"
                    exact
                    role="tab"
                    :aria-label="$t(`profile.tabs.${tab.id}`) || tab.id"
                    :aria-selected="$route.path === tab.route"
                    :tabindex="$route.path === tab.route ? 0 : -1"
                  >
                    <v-icon :aria-hidden="true">
                      {{ tab.icon }}
                    </v-icon>
                    <span class="sr-only">{{ $t(`profile.tabs.${tab.id}`) || tab.id }}</span>
                  </v-tab>
                </v-tabs>

                <router-view
                  :username="username"
                  :email="email"
                  :zushin-points="zushinPoints"
                  :total-referred="totalReferred"
                  :total-referred-completed="totalReferredCompleted"
                  :referral-link="referralLink"
                  role="region"
                  aria-live="polite"
                  aria-label="Dashboard layout section"
                />
              </v-container>
            </v-card>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import { mapGetters } from "vuex";
import tabs from "@/constants/profile.tabs";

export default {
    name: "DashoardLayout",
    data() {
        return {
            tabs: tabs.list,
            verifyEmailText: "",
            verifiedAlertStyle: {
                icon: "info",
                type: "info"
            },
            isEmailSent: false,
            isLoading: false
        }
    },
    computed: mapGetters([
        "nickname",
        "username",
        "email",
        "isVerifiedEmail",
        "zushinPoints",
        "totalReferred",
        "totalReferredCompleted",
        "referralLink"
    ]),
    beforeMount() {
        this.verifyEmailText = this.$t("components.profile.notVerifiedEmail");
    },
    methods: {
        verifyEmail() {
            if (this.isEmailSent) {
                return;
            }
            this.isEmailSent = true;
            this.isLoading = true;
            this.$api
                .verifyEmail()
                .then(() => {
                    this.isLoading = false;
                    this.verifiedAlertStyle = {
                        type: "success",
                        icon: "check_circle"
                    };
                    this.verifyEmailText = this.$t(
                        "components.profile.sentVerifyEmail"
                    );
                })
                .catch(() => {
                    this.isLoading = false;
                    this.verifyEmailText = this.$t(
                        "components.profile.failedVerifyEmail"
                    );
                    this.verifiedAlertStyle = {
                        type: "error",
                        icon: "warning"
                    };
                });
        }
    }
};
</script>

<style lang="scss" scoped>
@import '~/_variables.scss';

    .profile-section-card--flex-toolbar{
        margin-top: -64px;
    }

.sr-only {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
</style>
